import { FASTRADE } from "../actions/types";

export const fastrade = (state = false, action) => {
  switch (action.type) {
    case FASTRADE:
      return action.payload;
    default:
      return state;
  }
};
